// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading--OCByW","spinWrap":"spinWrap--23_ik","logo":"logo--2JyHy"};